import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import { channelActions } from '../../../_actions';
import { Input } from '../../../_components';

import Amazon from '../../../_assets/amazonses-logo.png';

import moment from 'moment';

class AmazonSesModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      accessKeyId: null,
      secretAccessKey: null,
      region: null,
      source: null,
      submitting: false,
      submitted: false
    }

    this.closeModal = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.activeChannels.forEach(element => {
      if (element.channel_type === 'AWS_SES') {
        this.setState({
          accessKeyId: element.properties.accessKeyId,
          secretAccessKey: element.properties.secretAccessKey,
          region: element.properties.region,
          source: element.properties.source,
          uuid: element.uuid,
          updated_at: element.updated_at
        })
      }
    });
  }

  handleChange(e) {
    let name = e.target.name;
    let value = e.target.value;

    this.setState({[name]: value});
  }

  handleSubmit(e) {
    e.preventDefault();

    let self = this;

    const { accessKeyId, secretAccessKey, region, source, uuid } = this.state;
    const { dispatch, actionType } = this.props;
    
    this.setState({submitting: true, submitted: true});
    
    if ( !accessKeyId && !secretAccessKey && !region && !source ) 
      return this.setState({submitting: false});

    let obj = {
      "channel": {
        "domain_uuid": JSON.parse(sessionStorage.getItem('selected_domain')).uuid,
        "channel_type": "AWS_SES",
        "properties": {
          "accessKeyId": accessKeyId,
          "secretAccessKey": secretAccessKey,
          "region": region,
          "source": source
        }
      }
    }

    if (actionType === 'view')
      return false

    let action
    let constant
    
    if (actionType === 'edit') {
      obj.channel['uuid'] = uuid;

      action = channelActions.update(obj);
      constant = 'UPDATE_INTEGRATION_FAILURE';
    } else {
      action = channelActions.create(obj);
      constant = 'CHANNEL_INTEGRATION_FAILURE';
    }

    dispatch(action)
      .then(data => {
        if ( data.type !== constant ) {
          this.props.evt.handleSubmit();

          self.setState({submitting: false});
  
          return toast.success(data.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            className: 'toast-success'
          });
        }
  
        self.setState({submitting: false})
  
        return toast.error(data.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          className: 'toast-error'
        });
      });
  }

  render() {
    const { submitted, submitting, accessKeyId, secretAccessKey, region, source } = this.state;
    const { actionType } = this.props;

    let title;
    let subtitle;
    let readOnly;
    let button;
    let buttonLoading;

    switch (actionType) {
      case 'edit':
        title = 'Editing AmazonSES channel'
        subtitle = 'It is necessary that you provide your AmazonSES AccessKeyID, SecretAccessKey, Region and Source in the fields below.'
        button = 'Edit'
        buttonLoading = 'Editing...'
        break;
      case 'view':
        title = 'AmazonSES channel information for this Domain'
        subtitle = 'Here you can you find the configured information for this channel.'
        readOnly = true
        break;
      default:
        title = 'Adding AmazonSES channel'
        subtitle = 'It is necessary that you provide your AmazonSES AccessKeyID, SecretAccessKey, Region and Source in the fields below.'
        button = 'Add'
        buttonLoading = 'Adding...'
        break;
    }

    return (
      <div className="modal fade" id={this.props.name+'Modal'} tabIndex="-1" role="dialog" aria-labelledby={this.props.name+'ModalLabel'} aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <img src={Amazon} alt="Amazon logo" style={{height: '55px'}}/>
              <br/>
              <br/>
              <p className="title">{title}</p>
              <p className="disclaimer">{subtitle}</p>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" ref={this.closeModal}>
                <i className="lnr lnr-cross"></i>
              </button>
              <form action="#" className="form clearfix" id="zenviaChannelForm" method="POST" onSubmit={this.handleSubmit}>
                <div className="content-group">
                  <Input
                    label="AccessKeyID"
                    type="text"
                    name="accessKeyId"
                    submitted={submitted}
                    property={accessKeyId}
                    hasChanged={this.handleChange}
                    onError="Provide your AmazonSES AccessKeyID"
                    readOnly={readOnly}
                  />

                  <Input
                    label="SecretAccessKey"
                    type="password"
                    name="secretAccessKey"
                    submitted={submitted}
                    property={secretAccessKey}
                    hasChanged={this.handleChange}
                    onError="Provide your AmazonSES Secret Access Key"
                    readOnly={readOnly}
                  />

                  <Input
                    label="Region"
                    type="text"
                    name="region"
                    submitted={submitted}
                    property={region}
                    hasChanged={this.handleChange}
                    onError="Provide your AmazonSES Region"
                    readOnly={readOnly}
                  />

                  <Input
                    label="Source"
                    type="text"
                    name="source"
                    submitted={submitted}
                    property={source}
                    hasChanged={this.handleChange}
                    onError="Provide your AmazonSES Source"
                    readOnly={readOnly}
                  />
                  
                </div>
                {
                  submitting ?
                    <button type="button" className="btn btn-blue float-right disabled" disabled>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      <span className="sr-only"> {buttonLoading}</span>
                    </button>    
                  : actionType === 'view' ?
                    <button type="submit" className="btn btn-blue float-right" data-dismiss="modal">OK</button> :
                    <button type="submit" className="btn btn-blue float-right">{button}</button>
                }
              </form>
              {
                actionType ?
                  <p className="edit">Last update: {moment(this.state.updated_at).format('MMMM Do YYYY, h:mm:ss a')}</p>
                : ''
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { channelStatus } = state.createChannel;
  return channelStatus;
}

const ConnectedAmazonSesModal = connect(mapStateToProps)(AmazonSesModal);
export { ConnectedAmazonSesModal as AmazonSesModal }